import contract from 'truffle-contract'

import config from '../config'

const AragonTokenSale = contract({
  abi: JSON.parse(config.saleABI),
  unlinked_binary: '0x6061', // fake, no need to deploy
})

if (window.web3) {
  AragonTokenSale.setProvider(window.web3.currentProvider)
}

export default AragonTokenSale



// WEBPACK FOOTER //
// ./src/lib/AragonTokenSale.js